module.exports = __webpack_public_path__ + "static/media/left.c42e2ba6.ico";